import {combineReducers} from 'redux'
import {fork} from 'redux-saga/effects'
import main, {saga as mainSaga} from './ducks/main'

export const reducer = combineReducers({
  main
})

export const saga = function * () {
  yield fork(mainSaga)
}
